<template>
	<div>
		<div v-for="(claim, claimIndex) in printClaims" :key="claim.id">
			<div
				style="margin: 60px 0; border: thin solid rgba(25, 42, 62, 0.3)"
				:style="{ breakAfter: getClaimImages(claim).length > 0 || claimIndex < printClaims.length - 1 ? 'page' : 'auto' }"
			>
				<div style="border-bottom: thin solid rgba(25, 42, 62, 0.2);padding: 10px 16px;display: flex;flex-flow: row nowrap;justify-content: space-between;align-items: center; background: #FAFAFA">
					<div style="display: flex;flex-flow: column nowrap;align-items: flex-start;">
						<div style="font-family: roboto, sans-serif;font-style: normal;font-weight: 500;font-size: 14px;color: #192A3E;">
							Claim number&nbsp;&nbsp;<span>#{{claim.number}}</span>
						</div>
						<div style="padding-top: 4px;font-family: roboto, sans-serif;font-style: normal;font-weight: 400;font-size: 12px;color: rgba(25, 42, 62, 0.7);">
							Claim Date&nbsp;&nbsp;<span style="color: #192A3E;">{{ formatDate(claim.claim_date) }}</span>
						</div>
						<div style="padding-top: 4px;font-family: roboto, sans-serif;font-style: normal;font-weight: 400;font-size: 12px;color: rgba(25, 42, 62, 0.7);">
							Claim Description:&nbsp;&nbsp;<span style="color: #192A3E;">{{claim.desc}}</span>
						</div>
						<div style="padding-top: 4px;font-family: roboto, sans-serif;font-style: normal;font-weight: 400;font-size: 12px;color: rgba(25, 42, 62, 0.7);">
							Employee:&nbsp;&nbsp;<span style="color: #192A3E;">{{claim.employee}}</span>
						</div>
						<div style="padding-top: 4px;font-family: roboto, sans-serif;font-style: normal;font-weight: 400;font-size: 12px;color: rgba(25, 42, 62, 0.7);">
							Approver:&nbsp;&nbsp;<span style="color: #192A3E;">{{claim.approval_by}}</span>
						</div>
					</div>
					<div style="display: flex;flex-flow: column nowrap;align-items: flex-end;">
						<div style="font-family: roboto, sans-serif;font-style: normal;font-weight: 500;font-size: 14px;color: #000000;">Total</div>
						<div style="font-family: roboto, sans-serif;font-style: normal;font-weight: 400;font-size: 24px;color: #000000;">
							<span>{{claim.currency}}</span>&nbsp;&nbsp;
							<span>{{ formatNumber(claim.value) }}</span>
						</div>
					</div>
				</div>
				<v-simple-table>
					<template v-slot:default>
						<thead>
							<tr style="width: 100%;height: 48px;color: #192A3E; background: #FAFAFA;font-family: roboto, sans-serif;font-style: normal;font-weight: 500;font-size: 12px;">
								<th style="padding-left: 16px; width: 130px; text-align: left;">Expense date</th>
								<th style="width: 170px; text-align: left;">Job</th>
								<th style="width: 100px; text-align: right;">Currency</th>
								<th v-if="isGST" style="width: 130px; text-align: right;">Amount (net)</th>
								<th v-if="isGST" style="width: 140px; text-align: right;">GST</th>
								<th v-if="isGST" style="width: 140px; text-align: right;padding-right: 15px">To Pay</th>
								<th v-if="!isGST" style="width: 140px; text-align: right;padding-right: 15px">Amount</th>
								<th style="padding-right: 16px;width: 140px; text-align: left;">Kind</th>
								<th style="padding-right: 16px;width: 140px; text-align: left;">Notes</th>
							</tr>
						</thead>
						<tbody>
							<tr style="width: 100%; height: 48px; font-family: roboto, sans-serif;font-style: normal;font-weight: 400;font-size: 14px;color: #192A3E;" v-for="(detail, index) in claim.details" :key="`${index}_${detail.id}`">
								<td style="padding-left: 16px;width: 130px;text-align: left;">{{ detail.receipt ? detail.receipt.date : detail.date }}</td>
								<td style="width: 140px;text-align: left;">
									<div>{{ detail.job.code }}</div>
									<div>{{ detail.job.display_name }}</div>
								</td>
								<td style="width: 130px;text-align: right;">{{ detail.receipt ? detail.receipt.currency.symbol : detail.currency.symbol }}</td>
								<td v-if="isGST" style="width: 140px">
									<div style="text-align: right">{{ formatNumber(detail.gross) }}</div>
								</td>
								<td v-if="isGST" style="width: 140px">
									<div style="text-align: right">{{ formatNumber(detail.tax_amount) }}</div>
								</td>
								<td style="width: 140px;">
									<div style="text-align: right;padding-right: 15px">{{ formatNumber(detail.amount) }}</div>
								</td>
								<td style="padding-right: 16px;width: 140px;text-align: left;">{{ detail.kind.display_name }}</td>
								<td style="padding-right: 16px;width: 140px;text-align: left;">{{ detail.description }}</td>
							</tr>
						</tbody>
					</template>
				</v-simple-table>
			</div>
			<div
				style="display: flex;flex-flow: column nowrap;align-items: center"
				:style="{ breakAfter: index < getClaimImages(claim).length - 1 || claimIndex < printClaims.length - 1 ? 'page' : 'auto' }"
				v-for="(image, index) in getClaimImages(claim)"
				:key="`${index}_${image.id}`"
			>
				<div v-if="image.id === claim.id && typeof(image.image) === 'string'">
					<img
						:src="image.image" 
						:width="image.width" 
						:height="image.height" 
						alt="receipt" />
				</div>
				<template v-if="image.id === claim.id && Array.isArray(image.image)">
					<div
						v-for="(image_item, index) in image.image"
						:key="`${index}_${image_item.id}`"
						:style="{ breakBefore: index > 0 ? 'page' : 'auto' }"
					>
						<img
							:src="image_item" 
							width="100%"
							alt="receipt" /> 
					</div>
				</template>
			</div>
		</div>
	</div>
</template>
<script>
import moment from 'moment';

export default {
	name: 'PrintClaims', 
	props: {
		printClaims: {
			type: Array,
			default: () => []
		},
		isGST: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {}
	},
	methods: {
		getClaimImages(claim) {
			return (claim.image_arr || []).filter(image => image.id === claim.id);
		},
		formatDate(value) {
			if(!value) return null;
			return moment(value).format('DD MMM YYYY');
		},
		formatNumber(num) {
			if (typeof num === 'string' && num.includes(',')) {
				return num;
			}

			let res = 0;
			if (Number.isInteger(num)) {
				const integer = num.toLocaleString();
				res = integer + '.00';
			} else {
				const num_arr = (num.toString()).split('.');
				const integer = Number(num_arr[0]).toLocaleString();

				if (num_arr.length > 1) {
					if (num_arr[1].length === 1) {
						res = integer + '.' + num_arr[1] + '0';
					} else {
						res = integer + '.' + num_arr[1];
					}
					
				} else {
					res = integer + '.00' ;
				}
			}
			return res;
		},
	}

}
</script>
